import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PRICING_INCLUDED } from "@/lib/data";

const Pricing = () => {
  return (
    <section className="py-24 lg:py-32 bg-cream" data-testid="pricing-section">
      <div className="container-tm grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <span className="overline">Tarif</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Une formule simple
            <span className="italic text-sage"> et transparente</span>.
          </h2>

          <div className="mt-10 bg-white rounded-3xl p-10 shadow-lift border border-ink/5">
            <span className="pill mb-5">Commission unique</span>
            <div className="flex items-baseline gap-2 mt-2">
              <span className="font-serif text-7xl md:text-8xl text-ink leading-none">15<span className="text-gold">%</span></span>
              <span className="font-sans text-sm uppercase tracking-[0.2em] text-ink/60 ml-2">TTC</span>
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.22em] font-semibold text-sage">
              De chaque réservation
            </p>
            <p className="mt-6 font-sans text-sm text-ink/65 leading-relaxed">
              Frais de ménage à la charge du voyageur. <strong className="text-ink">Linge non inclus</strong> (option dédiée). Aucun frais de dossier.
            </p>

            <Link
              to="/contact"
              state={{ scrollTo: "simulator" }}
              className="btn-accent mt-8 w-full"
              data-testid="pricing-cta-calculate"
            >
              Calculez vos revenus
            </Link>
          </div>

          <div className="mt-5 p-6 bg-sage/5 border border-sage/20 rounded-2xl">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-sage mb-2">Linge, option voyageur</p>
            <p className="font-sans text-sm text-ink/75 leading-relaxed">
              Le linge de lit et de toilette <strong className="text-ink">n'est pas inclus</strong> dans la formule à 15 %. Par défaut, les voyageurs apportent leur propre linge.
            </p>
            <p className="mt-3 font-sans text-sm text-ink/75 leading-relaxed">
              S'ils préfèrent, ils peuvent souscrire <strong className="text-ink">l'option linge premium</strong> directement auprès de nous : draps-housses (jusqu'à 160×200 cm), housses de couette (jusqu'à 220×240 cm), taies d'oreiller et serviettes de toilette livrés et installés à leur arrivée. Cette option leur est <strong className="text-ink">facturée à eux</strong>, jamais à vous, c'est neutre côté propriétaire.
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="overline mb-4 inline-block">Ce qui est inclus</span>
          <h3 className="font-serif text-3xl md:text-4xl text-ink mb-10 max-w-lg leading-tight">
            Une prestation clé en main, sans surprise.
          </h3>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {PRICING_INCLUDED.map((item, i) => (
              <li
                key={i}
                data-testid={`pricing-included-${i}`}
                className="flex items-start gap-3 font-sans text-sm text-ink/80 leading-relaxed border-b border-ink/10 pb-4"
              >
                <span className="w-6 h-6 rounded-full bg-sage/10 flex items-center justify-center shrink-0 mt-0.5">
                  <Check size={13} strokeWidth={2.5} className="text-sage" />
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 bg-ink rounded-2xl p-8 text-white">
            <span className="overline text-gold mb-3 inline-block">Comment ça marche ?</span>
            <p className="font-sans text-sm md:text-base text-white/80 leading-relaxed">
              Notre commission est de <strong className="text-white">15 % TTC</strong> par réservation. Le ménage est à la charge du voyageur (refacturé via la plateforme). Le <strong className="text-white">linge de lit et de toilette n'est pas inclus</strong> : par défaut les voyageurs apportent le leur, ou bien ils peuvent souscrire l'option linge premium auprès de nous (facturée à eux, pas à vous). Vous encaissez les revenus, nous vous envoyons une facture de prestation en fin de mois.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
